import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { useText } from "@/lib/useText";

const UNITS = [["dias", 86400], ["horas", 3600], ["min", 60], ["seg", 1]];

function split(ms) {
  let s = Math.max(0, Math.floor(ms / 1000));
  return UNITS.map(([label, size]) => {
    const v = Math.floor(s / size);
    s -= v * size;
    return [label, v];
  });
}

export function Countdown({ hero }) {
  const t = useText();
  const target = hero.countdown_enabled && hero.countdown_date ? new Date(hero.countdown_date).getTime() : null;
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!target) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target || Number.isNaN(target)) return null;
  const remaining = target - now;
  const done = remaining <= 0;

  return (
    <div className="mt-10 inline-flex max-w-full flex-col gap-4 border border-eden-border bg-eden-surface/70 px-6 py-5 backdrop-blur-md animate-fade-up [animation-delay:200ms]" role="timer" aria-live="off" data-testid="countdown">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-eden-orange" data-testid="countdown-title">
        <Timer size={14} aria-hidden="true" /> {hero.countdown_title || t("countdown_default")}
      </p>
      {done ? (
        <p className="text-lg font-bold text-eden-text" data-testid="countdown-done">{hero.countdown_done_text || "Já começou!"}</p>
      ) : (
        <div className="flex gap-5 sm:gap-8">
          {split(remaining).map(([label, v]) => (
            <div key={label} className="text-left" data-testid={`countdown-${label}`}>
              <span className="block font-mono text-3xl font-extrabold tabular-nums leading-none text-eden-text sm:text-4xl">{String(v).padStart(2, "0")}</span>
              <span className="mt-1 block text-[11px] uppercase tracking-widest text-eden-muted">{label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
